"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
const React = require("react");
const chart_1 = require("../chart");
exports.LineChart = React.forwardRef((props, ref) => {
    const optionsLine = Object.assign({ plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    padding: 30,
                },
            },
        }, layout: {
            padding: {
                top: 20,
                left: 20,
                bottom: 20,
                right: 40,
            },
        } }, props.options);
    return React.createElement(chart_1.ChartJS, Object.assign({}, props, { type: 'line', options: optionsLine, ref: ref }));
});
